import { Divider, Heading } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { getActivity } from '../../../service';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import ParticipationContentItemActivityTab from './ParticipationContentItemActivityTab';
import ParticipationContentItemActivityGallery from './ParticipationContentItemActivityGallery';
import ParticipationContentItemActivityFull from './ParticipationContentItemActivityFull';
import { activityTitles } from '../meta';
import ParticipationContentItemActivityRepeat from './ParticipationContentItemActivityRepeat';

const { flexBoxDirection, participationSideBoxWidth, participationContentBoxWidth } = responsiveValue;

type Props = {
  activity_cateogry: string;
};

function ParticipationContentItemActivity({ activity_cateogry }: Props) {

  const { isLoading, error, data } = useQuery('ParticipationContentItemActivity', () => getActivity(`${activity_cateogry}`));
  const title = activityTitles(activity_cateogry);

  if (activity_cateogry === '36') {
    return (
      <>
      {
        !isLoading && !error && data && (
          <>
          <Divider mt="14" mb="14" color="b.lg" />
          <Heading size="4xl" color="b.dgr" pb="9">{title}</Heading>
          <ParticipationContentItemActivityFull data={data} />
          </>
        )
      }
      </>
    );  
  }
  

  if (activity_cateogry === '47') { // 출판
    return (
      <>
      {
        !isLoading && !error && data && (
          <>
          <Heading size="4xl" color="b.dgr" pb="9">{title}</Heading>
          <ParticipationContentItemActivityGallery data={data} />
          </>
        )
      }
      </>
    );  
  }

  if (activity_cateogry === '41'  || activity_cateogry === '33' || activity_cateogry === '34') { // 시민과학풀씨
    return (
      <>
      {
        !isLoading && !error && data && (
          <>
          <Divider mt="14" mb="14" color="b.lg" />
          <Heading size="4xl" color="b.dgr" pb="9">{title}</Heading>
          <ParticipationContentItemActivityRepeat data={data} />
          </>
        )
      }
      </>
    );  
  }



  return (
    <>
    {
      !isLoading && !error && data && (
        <>
        <Divider mt="14" mb="14" color="b.lg" />
        <Heading size="4xl" color="b.dgr" pb="9">{title}</Heading>
        <ParticipationContentItemActivityTab data={data} category={activity_cateogry} />
        </>
      )
    }
    </>
  );
}

ParticipationContentItemActivity.defaultProps = {
};

export default ParticipationContentItemActivity;
